import { IAppState } from '../../../AppModulesWrapper';

import { ICoordinates } from '../../types/reducers/offer';

const MOSCOW_CENTER_COORDINATES: ICoordinates = {
  lat: 55.755864,
  lng: 37.621255,
};

export function selectOfferCoordinates(state: IAppState): ICoordinates {
  const { offer } = state.servicePickerWidget;

  const offerCoordinates = offer.geo?.coordinates;

  return offerCoordinates || MOSCOW_CENTER_COORDINATES;
}
